import { Clock } from "./Clock";
import { Name } from "./Name";
import { Score } from "./Score";
import { ScoresByQuarterMini } from "./ScoresByQuarterMini";
import { BugStat } from "./BugStat";
import { PlayerStats } from "./PlayerStats";
import { ScoresByQuarter } from "./ScoresByQuarter";
import { Formation } from "./Formation";
import { MatchFacts } from "./MatchFacts";
import { TeamCrawl } from "./TeamCrawl";
import { MatchIdent } from "./MatchIdent";
import { ScoreStream } from "./ScoreStream";
import { OpenerSlate } from "./OpenerSlate";
import { TechincalSlate } from "./TechnicalSlate";
import { Guest } from "./Guest";
import { Page } from "./Page";
import { SOFFormation } from "./SOFFormation";
import { Table } from "./Table";
import { Amex } from "./Amex";
import { Timeout } from "./Timeout";

export default function graphics({
  takeVizPage: animate,
  update,
  takeOutVizPage: animateOff,
  triggerAnimation,
  clearPreview,
  previewTrio: preview,
  getVizPage,
  updateVizPage,
  vizSharedMemory,
}) {
  return [
    new Clock({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Name({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
      vizSharedMemory,
    }),
    new Score({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new ScoresByQuarter({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new ScoresByQuarterMini({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new BugStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new PlayerStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new Formation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new MatchFacts({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new TeamCrawl({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new MatchIdent({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new ScoreStream({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new OpenerSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new TechincalSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new Guest({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new Page({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new SOFFormation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
    new Table({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
        new Amex({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
            new Timeout({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      getVizPage,
      updateVizPage,
    }),
  ];
}
